"use client";

import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { MapPin, Calendar as CalendarIcon, Users, ArrowRight } from "lucide-react";
function BookingForm() {
  const {
    control,
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm
  } = useWvcForm();
  const [serviceType, setServiceType] = useState("");
  const [checkInDate, setCheckInDate] = useState<Date | undefined>();
  const [checkOutDate, setCheckOutDate] = useState<Date | undefined>();
  const [departureDate, setDepartureDate] = useState<Date | undefined>();
  const [returnDate, setReturnDate] = useState<Date | undefined>();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-green-50/80 backdrop-blur-sm border border-green-200 rounded-xl">
				<p className="text-green-800 font-semibold">{successMessage}</p>
				<Button onClick={resetForm} variant="outline" className="mt-4">
					Másik foglalás
				</Button>
			</div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
			<FormField control={control} name="name" rules={{
      required: "A név szükséges"
    }} render={({
      field
    }) => <FormItem>
						<FormLabel className="font-default">Teljes név</FormLabel>
						<FormControl>
							<Input placeholder="János Kovács" {...field} className="bg-white/50 backdrop-blur-sm border-white/20" />
						</FormControl>
						<FormMessage />
					</FormItem>} />

			<FormField control={control} name="email" rules={{
      required: "Az e-mail szükséges",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Érvényes e-mail címet adjon meg"
      }
    }} render={({
      field
    }) => <FormItem>
						<FormLabel className="font-default">E-mail cím</FormLabel>
						<FormControl>
							<Input type="email" placeholder="janos@example.com" {...field} className="bg-white/50 backdrop-blur-sm border-white/20" />
						</FormControl>
						<FormMessage />
					</FormItem>} />

			<FormField control={control} name="phone" rules={{}} render={({
      field
    }) => <FormItem>
						<FormLabel className="font-default">Telefonszám</FormLabel>
						<FormControl>
							<Input type="tel" placeholder="+36 20 123 4567" {...field} className="bg-white/50 backdrop-blur-sm border-white/20" />
						</FormControl>
						<FormDescription>Opcionális, de hasznos a gyors kapcsolatfelvételhez.</FormDescription>
						<FormMessage />
					</FormItem>} />

			<FormField control={control} name="service_type" rules={{
      required: "Válasszon szolgáltatást"
    }} render={({
      field
    }) => <FormItem>
						<FormLabel className="font-default">Szolgáltatás típusa</FormLabel>
						<FormControl>
							<Select value={field.value} onValueChange={value => {
          field.onChange(value);
          setServiceType(value);
        }}>
								<SelectTrigger className="bg-white/50 backdrop-blur-sm border-white/20">
									<SelectValue placeholder="Válasszon szolgáltatást" />
								</SelectTrigger>
								<SelectContent>
									<SelectItem value="Ski Reservation">Síelési foglalás</SelectItem>
									<SelectItem value="Flight Booking">Repülőjegy foglalás</SelectItem>
									<SelectItem value="Taxi Booking">Taxi Foglalás</SelectItem>
									<SelectItem value="Car Rental">Autó Bérlés</SelectItem>
								</SelectContent>
							</Select>
						</FormControl>
						<FormMessage />
					</FormItem>} />

			<FormField control={control} name="details" rules={{}} render={({
      field
    }) => <FormItem>
						<FormLabel className="font-default">Foglalás részletei</FormLabel>
						<FormControl>
							<textarea placeholder="Adjon meg részleteket, például síutca, repülési dátumok, felszállási hely vagy bérleti időszak." {...field} rows={4} className="w-full px-3 py-2 border border-white/20 rounded-md bg-white/50 backdrop-blur-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50" />
						</FormControl>
						<FormDescription>Minél több információt ad, annál gyorsabban feldolgozzuk a kérelmet.</FormDescription>
						<FormMessage />
					</FormItem>} />

			{submitError && <div className="p-4 bg-red-50/80 backdrop-blur-sm border border-red-200 rounded-lg">
					<p className="text-red-800 text-sm">{submitError}</p>
				</div>}

			<Button type="submit" disabled={isSubmitting} className="w-full h-11 bg-gradient-to-r from-blue-500 to-cyan-400 hover:from-blue-600 hover:to-cyan-500 text-white font-semibold">
				{isSubmitting ? "Küldés folyamatban..." : "Foglalás indítása"}
				<ArrowRight className="size-4" />
			</Button>
		</Form>;
}
export default function BookingHub() {
  return;
}